<template>
	<div>
		<input type="color" v-model="c_value" @input="mixin_inputEvent" @change="mixin_saveEvent"
			:disabled="is_disabled" :readonly="c_ctrlParams.isReadOnly" />
		<div class="ctrl-extraDescr" v-if="c_ctrlParams.extraDescr" v-html="c_ctrlParams.extraDescr"></div>
	</div>
</template>

<script>
	// КОНТРОЛ ВЫБОРА ЦВЕТА ИЗ ПАЛИТРЫ
	import ctrlMixins from './_mixins.js'
	import { ctrlParamsForAll } from './_common-stuff.ts';

	export default {
		name: 'color_picker',
		mixins: [ ctrlMixins ], // c_value, c_ctrlParams, c_srv_options, пропсы view_type, field_meta и так далее
		meta: {
			title: 'Выбор цвета из палитры',
			params: {
				defaultColor: {
					name: 'Цвет по умолчанию',
					editType: 'colorPicker'
				},
				...ctrlParamsForAll,
			}
		},
		mounted() {
			this.$emit('update:value', this.c_value || this.c_ctrlParams.defaultColor || '#000');
		},
		props: { // большая часть пропсов приезжает из ctrlMixins!
			value: {
				default: '',
			},
		}
	}
</script>
